import { SearchInput, SearchInputField } from '@frontend/components';

interface OptionalGroupsInputFilterProps {
  value: string;
  handleClear: () => void;
  handleChange: () => void;
}

const OptionalGroupsInputFilter = ({
  handleClear,
  handleChange,
  value,
}: OptionalGroupsInputFilterProps) => (
  <SearchInput
    mode="live"
    size="md"
    value={value}
    onChange={handleChange}
    onClear={handleClear}
  >
    <SearchInputField autoFocus={true} placeholder="Search all organizations" />
  </SearchInput>
);

export default OptionalGroupsInputFilter;
